import type { MaintenanceNotice } from "./notice";

/** Where the app keeps the maintenance hold it has been told about, so one screen can take over everything. */
export type MaintenanceStore = {
  readonly get: () => MaintenanceNotice | undefined;
  readonly subscribe: (listener: () => void) => () => void;
  readonly report: (notice: MaintenanceNotice) => void;
};

export function createMaintenanceStore(): MaintenanceStore {
  let current: MaintenanceNotice | undefined;
  const listeners = new Set<() => void>();
  return {
    get: () => current,
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    report(notice) {
      current = notice;
      listeners.forEach((listener) => listener());
    },
  };
}
